<template>
	<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
		<div class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-12">
						<h5 class="p0 mb0">
							<strong>Pedidos Internos</strong>
						</h5>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<hr class="hrText" data-content="♦" />
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<insertOrUpdateInternalOrders />
					</div>
				</div>
			</div>
		</div>
	</a-spin>
</template>
<script>
//
import { mapGetters } from 'vuex'
import insertOrUpdateInternalOrders from '@/components/internalOrders'

export default {
	name: 'insertOrUpdateInternalOrdersView',
	components: {
		insertOrUpdateInternalOrders,
	},
	computed: {
		...mapGetters('internalOrders', ['spinnerLoader', 'spinnerLoaderLabel']),
	},
}
</script>